/**
 * Stane Product Inline Scripts
 * Extracted from layout/theme.liquid for performance (cacheable + deferred)
 * Contains: Slick slider init, variant filtering, stock message, sticky ATC,
 *           upsell/accessory handlers, price calculation, customize input trigger
 */

$(document).ready(function () {
  console.log("Document ready");

  // Store original slides HTML
  const originalSlides = $(".main-slider_mn .slider__item").map(function () {
    return $(this).prop('outerHTML');
  }).get();

  // Function to initialize all slides
  function initializeAllSlides() {
    destroySliders();
    $('.main-slider_mn, .thumbnail-slider-mn').empty();

    originalSlides.forEach(function (slideHTML) {
      const $slide = $(slideHTML);
      const $mainSlide = $slide.clone();
      const $thumbSlide = $slide.clone();

      $('.main-slider_mn').append($mainSlide);
      $('.thumbnail-slider-mn').append($thumbSlide);
    });

    setTimeout(initializeSliders, 150);
  }

  // Check if custom_color_input exists
  const $customInputs = $('.option-selector__btns input.custom_color_input');
  const hasCustomInputs = $customInputs.length > 0;

  if (hasCustomInputs) {
    const initiallyChecked = $customInputs.filter(':checked');
    if (initiallyChecked.length > 0) {
      updateSliderByValue(initiallyChecked.data('name'));
    } else {
      initializeAllSlides();
    }

    $(document).on('click', '.option-selector__btns input.custom_color_input', function () {
      updateSliderByValue($(this).data('name'));
    });
  } else {
    initializeAllSlides();
  }

  // Update slider with matched slides
  function updateSliderByValue(value) {
    const selectedValue = value?.toLowerCase().trim();
    console.log('Selected variant:', selectedValue);

    destroySliders();
    $('.main-slider_mn, .thumbnail-slider-mn').empty();

    let hasMatches = false;
    let slidesToShow = [];

    originalSlides.forEach(function (slideHTML) {
      const $slide = $(slideHTML);
      const slideAlt = $slide.data('alt') || '';
      let variants = [];

      if (slideAlt.includes(',')) {
        variants = slideAlt.split(',').map(v => v.trim().toLowerCase());
      } else if (slideAlt.includes('-')) {
        variants = slideAlt.split('-').map(v => v.trim().toLowerCase());
      } else {
        variants = [slideAlt.trim().toLowerCase()];
      }

      if (variants.includes(selectedValue)) {
        slidesToShow.push(slideHTML);
        hasMatches = true;
      }
    });

    if (!hasMatches) {
      console.log('No matches - showing all variants');
      slidesToShow = originalSlides;
    }

    slidesToShow.forEach(function (slideHTML) {
      const $slide = $(slideHTML);
      const $mainSlide = $slide.clone();
      const $thumbSlide = $slide.clone();

      $('.main-slider_mn').append($mainSlide);
      $('.thumbnail-slider-mn').append($thumbSlide);
    });

    setTimeout(initializeSliders, 150);
  }

  // Destroy sliders
  function destroySliders() {
    try {
      if ($('.main-slider_mn').hasClass('slick-initialized')) {
        $('.main-slider_mn').slick('unslick');
      }
      if ($('.thumbnail-slider-mn').hasClass('slick-initialized')) {
        $('.thumbnail-slider-mn').slick('unslick');
      }
    } catch (e) {
      console.log('Error destroying sliders:', e);
    }

    // Complete cleanup
    $('.main-slider_mn, .thumbnail-slider-mn')
      .removeClass('slick-initialized slick-slider')
      .removeAttr('style');
  }

  function initializeSliders() {
    const $main = $('.main-slider_mn');
    const $thumbs = $('.thumbnail-slider-mn');

    if ($main.children().length === 0) return;

    // Initialize main slider
    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      fade: true,
      cssEase: 'ease',
      speed: 400,
      adaptiveHeight: true,
      asNavFor: '.thumbnail-slider-mn',
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M10.0153 19.6114L11.7582 17.9012L3.68215 9.97658L11.7582 2.05197L10.0153 0.341797L0.196444 9.97658L10.0153 19.6114Z" fill="#fff"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M1.98473 19.6114L0.241882 17.9012L8.31791 9.97658L0.241882 2.05197L1.98473 0.341797L11.8036 9.97658L1.98473 19.6114Z" fill="white"></path></svg></button>'
    });

    // Initialize thumbnail slider
    $thumbs.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.main-slider_mn',
      dots: false,
      focusOnSelect: true,
      arrows: false,
      infinite: false,
      centerMode: false,
      variableWidth: false,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 4 } },
        { breakpoint: 480, settings: { slidesToShow: 3 } }
      ]
    });

    // Sync thumbnails on main slide change
    $main.on('afterChange', function(event, slick, currentSlide) {
      $('.thumbnail-slider-mn .slick-slide').removeClass('slick-current');
      $('.thumbnail-slider-mn .slick-slide[data-slick-index="'+ currentSlide +'"]').addClass('slick-current');
    });

    // Initialize active state and fix positioning
    setTimeout(function() {
      const currentSlide = $main.slick('slickCurrentSlide');
      $('.thumbnail-slider-mn .slick-slide').removeClass('slick-current');
      $('.thumbnail-slider-mn .slick-slide[data-slick-index="'+ currentSlide +'"]').addClass('slick-current');

      // Force thumbnail slider to reset position
      if ($thumbs.hasClass('slick-initialized')) {
        $thumbs.slick('slickGoTo', 0, true);
      }
    }, 100);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const targetSelector = '.ot-estimated-shipping-main-text-estimated';

  function injectStockMessage(target) {
    if (!target || target.querySelector('.stock-status')) return;

    const stockHTML = document.createElement('span');
    stockHTML.className = 'stock-status';
    stockHTML.innerHTML = '<span class="pulse-circle"></span>Op voorraad \u2014 ';

    const container = target.querySelector('div');
    if (container) {
      container.prepend(stockHTML);
    }
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      const target = document.querySelector(targetSelector);
      if (target) {
        injectStockMessage(target);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const stickyATCButtons = document.querySelector(".sticky-atc__buttons");
  const stickyForm = stickyATCButtons?.querySelector("form");

  if (!stickyATCButtons || !stickyForm) return;

  const observer = new MutationObserver((mutations, obs) => {
    const estimatedShipping = document.querySelector(".ot-estimated-shipping");

    if (estimatedShipping && estimatedShipping.innerText.trim() !== "" && !document.querySelector(".from-main-to-sticky")) {
      const clone = estimatedShipping.cloneNode(true);
      clone.classList.add("from-main-to-sticky");
      stickyATCButtons.insertBefore(clone, stickyForm);
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".mn_meta_prd");

  links.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const href = this.getAttribute("href");
      links.forEach(function (l) {
        l.classList.remove("active");
      });
      this.classList.add("active");
      this.classList.add("loading");
      setTimeout(function () {
        window.location.href = href;
      }, 500);
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('.js_st_ups_slider');

  if (container && typeof Flickity !== 'undefined') {
    new Flickity(container, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      draggable: true,
      imagesLoaded: true,
      friction: 0.6,              // higher friction = slows down quicker
      selectedAttraction: 0.10,   // stronger snap to cell
      dragThreshold: 3            // requires a slightly bigger drag to move
    });
  } else {
    console.error("Slider container not found or Flickity not loaded");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".st_ups-variant-select").forEach(function (select) {
    select.addEventListener("change", function (e) {
      e.stopPropagation();
      let selectedVid = this.value;
      let slide = this.closest(".st_ups_slide");
      if (slide) {
        slide.setAttribute("data-vid", selectedVid);
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".stt-accessory-variant-select").forEach(function (select) {
    select.addEventListener("change", function (e) {
      e.stopPropagation();
      let selectedVid = this.value;
      let slide = this.closest(".stt-accessory-card");
      if (slide) {
        slide.setAttribute("data-vid", selectedVid);
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Accessory Cards
  const accessoryCards = document.querySelectorAll('.stt-accessory-card');
  accessoryCards.forEach(card => {
    card.addEventListener('click', function(e) {
      if (!e.target.closest('.stt-accessory-link')) {
        e.preventDefault();
      }
      this.classList.toggle('selected');
      updateStickyATCPrice();
    });
  });

  document.querySelectorAll('.stt-accessory-link').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
    });
  });

  // Upsell Cards
  const upsellCards = document.querySelectorAll('.st_ups_slide');
  upsellCards.forEach(card => {
    card.addEventListener('click', function(e) {
      if (!e.target.closest('.st_ups_title a')) {
        e.preventDefault();
      }
      this.classList.toggle('selected');
      updateStickyATCPrice();
    });
  });

  document.querySelectorAll('.st_ups_title a').forEach(link => {
    link.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });

  // Combined Price Update Function
  function updateStickyATCPrice() {
    const stickyATC = document.querySelector('sticky-atc');
    if (!stickyATC) return;

    // Get main product price
    const mainPriceEl = stickyATC.querySelector('.reg-stc-pr[data-p]');
    if (!mainPriceEl) return;

    const mainPrice = parseInt(mainPriceEl.getAttribute('data-p')) || 0;
    let totalPrice = mainPrice;
    let totalComparePrice = 0;

    // Get main compare price
    const mainComparePriceEl = stickyATC.querySelector('.reg-stc-cpr[data-cp]');
    if (mainComparePriceEl && mainComparePriceEl.hasAttribute('data-cp')) {
      totalComparePrice = parseInt(mainComparePriceEl.getAttribute('data-cp')) || 0;
    }

    // Calculate accessories prices
    document.querySelectorAll('.stt-accessory-card.selected').forEach(item => {
      const priceEl = item.querySelector('.stt-price, .stt-price-sale');
      if (priceEl?.hasAttribute('data-price')) {
        totalPrice += parseInt(priceEl.getAttribute('data-price')) || 0;
      }

      const comparePriceEl = item.querySelector('.stt-price-original[data-cprice]');
      if (comparePriceEl?.hasAttribute('data-cprice')) {
        totalComparePrice += parseInt(comparePriceEl.getAttribute('data-cprice')) || 0;
      }
    });

    // Calculate upsell prices
    document.querySelectorAll('.st_ups_slide.selected').forEach(item => {
      const priceEl = item.querySelector('.st_ups_price');
      if (priceEl?.hasAttribute('data-price')) {
        totalPrice += parseInt(priceEl.getAttribute('data-price')) || 0;
      }

      const comparePriceEl = item.querySelector('.st_ups_compare-at');
      if (comparePriceEl?.hasAttribute('data-price')) {
        totalComparePrice += parseInt(comparePriceEl.getAttribute('data-price')) || 0;
      }
    });

    // Format money helper
    const formatMoney = (amount) => {
      return (amount / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: document.documentElement.lang === 'nl' ? 'EUR' : 'USD'
      });
    };

    // Update sticky ATC display
    mainPriceEl.textContent = formatMoney(totalPrice);

    if (mainComparePriceEl) {
      if (totalComparePrice > totalPrice) {
        mainComparePriceEl.textContent = formatMoney(totalComparePrice);
        mainComparePriceEl.hidden = false;

        const saveEl = stickyATC.querySelector('.reg-save-atc');
        if (saveEl) {
          const savings = totalComparePrice - totalPrice;
          const percentSaved = Math.round((savings * 100) / totalComparePrice);
          saveEl.textContent = ` bespaar (${percentSaved}%)`;
          saveEl.hidden = false;
        }
      } else {
        mainComparePriceEl.hidden = true;
        const saveEl = stickyATC.querySelector('.reg-save-atc');
        if (saveEl) saveEl.hidden = true;
      }
    }
  }

  // Listen for variant changes
  document.addEventListener('on:variant:change', updateStickyATCPrice);
});


document.addEventListener("DOMContentLoaded", () => {
  const priceEl = document.querySelector(".prd_page_price .js-value");
  const quantityInput = document.querySelector("input[name='quantity']");
  const addToCartBtn = document.querySelector(".add-to-cart");
  const discountWidget = document.querySelector(".quantity-x-product-widget");

  if (!priceEl || !quantityInput || !addToCartBtn) return;

  // Base price from data attribute (in cents)
  const basePrice = parseInt(priceEl.dataset.pr, 10);

  // Format cents to Euro
  function formatPrice(cents) {
    return (cents / 100).toLocaleString("nl-NL", {
      style: "currency",
      currency: "EUR"
    });
  }

  // Create / re-attach span for price
  function ensurePriceSpan() {
    let priceSpan = addToCartBtn.querySelector(".btn-price");
    if (!priceSpan) {
      priceSpan = document.createElement("span");
      priceSpan.className = "btn-price";
      priceSpan.style.display = "block";
      priceSpan.style.fontSize = "14px";
      priceSpan.style.fontWeight = "normal";
      priceSpan.style.whiteSpace = "nowrap";
      addToCartBtn.appendChild(priceSpan);
    }
    return priceSpan;
  }

  // Function to get discount %
  function getDiscount(qty) {
    if (qty >= 50) return 20;
    if (qty >= 20) return 15;
    if (qty >= 10) return 12;
    if (qty >= 5) return 10;
    return 0;
  }

  // Update price in button
  function updateButtonPrice() {
    const qty = parseInt(quantityInput.value, 10) || 1;
    let total = basePrice * qty;

    if (discountWidget) {
      const discount = getDiscount(qty);
      if (discount > 0) {
        total = total - (total * discount / 100);
      }
    }

    const priceSpan = ensurePriceSpan();
    priceSpan.textContent = formatPrice(Math.round(total));
  }

  // Init
  updateButtonPrice();

  // Quantity events
  quantityInput.addEventListener("change", updateButtonPrice);
  quantityInput.addEventListener("input", updateButtonPrice);

  // Swatches listener
  document.querySelectorAll(".option-selector input[type='radio']").forEach((swatch) => {
    swatch.addEventListener("change", () => {
      setTimeout(() => {
        updateButtonPrice();
      }, 100);
    });
  });
});



$(document).ready(function () {
    console.log("Document ready");

    const originalSlides = $(".main-slider_mn .slider__item").map(function () {
        return $(this).prop('outerHTML');
    }).get();

    function getCombinedOptionValue() {
        const values = [];
        $(".option-selector__btns input.custom_customize_input:checked").each(function () {
            const v = $(this).data("name")?.trim();
            if (v) values.push(v);
        });
        if (values.length === 0) return "";
        const combined = values.join(" + ");
        console.log("Combined Variant:", combined);
        return combined.toLowerCase().trim();
    }

    const $customInputs = $('.option-selector__btns input.custom_customize_input');
    const hasCustomInputs = $customInputs.length > 0;

    if (hasCustomInputs) {
        updateSliderByValue(getCombinedOptionValue());
        $(document).on('click', '.option-selector__btns input.custom_customize_input', function () {
            updateSliderByValue(getCombinedOptionValue());
        });
    } else {
        initializeAllSlides();
    }

    function updateSliderByValue(combinedValue) {
        destroySliders();
        $('.main-slider_mn, .thumbnail-slider-mn').empty();

        let slidesToShow = [];
        let hasMatches = false;

        originalSlides.forEach(function (slideHTML) {
            const $slide = $(slideHTML);
            const slideAlt = ($slide.data("alt") || "").toLowerCase();
            const variants = slideAlt.split(',').map(v => v.trim());

            if (combinedValue && variants.includes(combinedValue)) {
                slidesToShow.push(slideHTML);
                hasMatches = true;
            }
        });

        if (!hasMatches) slidesToShow = originalSlides;

        slidesToShow.forEach(function (slideHTML) {
            const $slide = $(slideHTML);

            const $mainSlide = $slide.clone()
                .removeClass('slick-slide slick-current slick-active')
                .removeAttr('style data-slick-index aria-hidden tabindex')
                .attr('data-alt', $slide.data("alt"));

            const $thumbSlide = $slide.clone()
                .removeClass('slick-slide slick-current slick-active')
                .removeAttr('style data-slick-index aria-hidden tabindex')
                .attr('data-alt', $slide.data("alt"));

            $('.main-slider_mn').append($mainSlide);
            $('.thumbnail-slider-mn').append($thumbSlide);
        });

        setTimeout(initializeSliders, 150);
    }

    function initializeAllSlides() {
        destroySliders();
        $('.main-slider_mn, .thumbnail-slider-mn').empty();

        originalSlides.forEach(function (slideHTML) {
            const $slide = $(slideHTML);

            const $mainSlide = $slide.clone()
                .removeClass('slick-slide slick-current slick-active')
                .removeAttr('style data-slick-index aria-hidden tabindex')
                .attr('data-alt', $slide.data("alt"));

            const $thumbSlide = $slide.clone()
                .removeClass('slick-slide slick-current slick-active')
                .removeAttr('style data-slick-index aria-hidden tabindex')
                .attr('data-alt', $slide.data("alt"));

            $('.main-slider_mn').append($mainSlide);
            $('.thumbnail-slider-mn').append($thumbSlide);
        });

        setTimeout(initializeSliders, 150);
    }

    function destroySliders() {
        try {
            if ($('.main-slider_mn').hasClass('slick-initialized')) {
                $('.main-slider_mn').slick('unslick');
            }
            if ($('.thumbnail-slider-mn').hasClass('slick-initialized')) {
                $('.thumbnail-slider-mn').slick('unslick');
            }
        } catch (e) {
            console.log('Error destroying sliders:', e);
        }

        $('.main-slider_mn, .thumbnail-slider-mn')
            .removeClass('slick-initialized slick-slider')
            .removeAttr('style');
    }

    function initializeSliders() {
        const $main = $('.main-slider_mn');
        const $thumbs = $('.thumbnail-slider-mn');

        if ($main.children().length === 0) return;

        $main.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            fade: true,
            cssEase: 'ease',
            speed: 400,
            adaptiveHeight: true,
            asNavFor: '.thumbnail-slider-mn',
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M10.0153 19.6114L11.7582 17.9012L3.68215 9.97658L11.7582 2.05197L10.0153 0.341797L0.196444 9.97658L10.0153 19.6114Z" fill="#fff"></path></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M1.98473 19.6114L0.241882 17.9012L8.31791 9.97658L0.241882 2.05197L1.98473 0.341797L11.8036 9.97658L1.98473 19.6114Z" fill="white"></path></svg></button>'
        });

        $thumbs.slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.main-slider_mn',
            focusOnSelect: true,
            arrows: false,
            infinite: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 5 } },
                { breakpoint: 768, settings: { slidesToShow: 4 } },
                { breakpoint: 480, settings: { slidesToShow: 5 } }
            ]
        });

        setTimeout(() => {
            if ($thumbs.hasClass('slick-initialized')) {
                $thumbs.slick('slickGoTo', 0, true);
            }
        }, 100);
    }
});

$(document).ready(function(){
  setTimeout(function(){
    // 18-08-2026 — deze regel klikte ONVOORWAARDELIJK de eerste optiepil aan,
    // 100 ms na het laden. Bedoeld om de galerijfilter één keer te laten draaien,
    // maar het gevolg was dat een `?variant=`-deeplink altijd terugsprong naar de
    // eerste maat: de server rendert de juiste pil aangevinkt (zie de toelichting
    // in snippets/variant-picker.liquid), en 100 ms later stond hij weer op
    // "140 x 60 cm". Gemeten: het checked-ATTRIBUUT stond goed, de checked-
    // PROPERTY niet — het teken dat de reset van een click kwam, niet van de HTML.
    //
    // Nu: is er al iets gekozen, klik dán díe pillen aan in plaats van de eerste.
    // Alle neveneffecten die de oorspronkelijke klik had (galerij, prijs) blijven
    // zo bestaan; alleen de keuze wordt niet meer overschreven. Zonder deeplink is
    // de eerste pil de gekozen pil en verandert er dus niets.
    var $gekozen = $(".custom_customize_input:checked");
    ($gekozen.length ? $gekozen : $(".custom_customize_input:first")).trigger("click");
  }, 100);
});
